export default "__VITE_ASSET__DohgW0b1__"